import { BUCKETS, CATEGORIES, DEFAULT_CHAIN, CHAINS } from "./metaData";
import { featuredProjects, trendingProjects } from "./homePageProjects";
import projects from "./projects";

import { makeKey } from "../utils/helpers";

const parents = {};
for (let i = 0; i < CATEGORIES.length; i++) {
    const cat = CATEGORIES[i];
    for (let j = 1; j < BUCKETS[cat].length; j++) {
        parents[makeKey(BUCKETS[cat][j])] = makeKey(cat);
    }
}

const insert = (processedData, project, chain) => {
    processedData[chain] = processedData[chain] || { total: 0, projects: [] };
    processedData[chain].total += 1;
    processedData[chain].projects.push(project);

    // Insert into tag groups
    const { tags = [] } = project;
    tags.forEach((tag) => {
        const newData = processedData[chain][makeKey(tag)] || {
            total: 0,
            projects: [],
        };
        newData.total += 1;
        newData.projects.push(project);
        processedData[chain][makeKey(tag)] = newData;

        const parentTag = parents[makeKey(tag)];
        if (parentTag && !tags.includes(parentTag.replaceAll('-', ' '))) {
            const newParentData = processedData[chain][parentTag] || {
                total: 0,
                projects: [],
            };
            if (
                !newParentData.projects.length ||
                newParentData.projects[newParentData.projects.length - 1].name !== project.name
            ) {
                newParentData.total += 1;
                newParentData.projects.push(project);
                processedData[chain][parentTag] = newParentData;
            }
        }
    });

    return processedData;
}

const [processedData, projectsByName] = projects.reduce(
    ([processed, projectsMap], project) => {
        const { chains = [], name } = project;
        chains.forEach(chain => {
            processed = insert(processed, project, chain);
        });

        projectsMap[makeKey(name)] = project;

        return [processed, projectsMap];
    },
    [{}, {}],
);

const store = {};

const getDataForChain = (chain) => {
    if (store[chain]) return store[chain];

    const targetChain = CHAINS.includes(chain) ? chain : DEFAULT_CHAIN;
    const featuredProjectsOfTargetChain = featuredProjects[targetChain] ||
        ((processedData[targetChain] || {}).projects || []).slice(0, 4);
    const trendingProjectsOfTargetChain = trendingProjects[targetChain] ||
        ((processedData[targetChain] || {}).projects || []).slice(0, 4);

    const data = {
        featuredProjects: featuredProjectsOfTargetChain
            .map(nameOrObj => typeof nameOrObj === 'string' ? projectsByName[makeKey(nameOrObj)] : nameOrObj)
            .filter(project => project.chains.includes(targetChain)),
        processedData: processedData[targetChain],
        trendingProjects: trendingProjectsOfTargetChain
            .map(nameOrObj => typeof nameOrObj === 'string' ? projectsByName[makeKey(nameOrObj)] : nameOrObj)
            .filter(project => project.chains.includes(targetChain)),
    };
    store[chain] = data;

    return data;
};

export {
    featuredProjects,
    getDataForChain,
    makeKey,
    processedData,
    projectsByName,
    trendingProjects,
}